import { SpinLoading } from "antd-mobile";
import { FC } from "react";
import "./Loading.scoped.scss";

const Loading: FC = () => {
    return (
        <div className="loading">
            <SpinLoading style={{ "--size": "32px" }} />
            <div className="txt">加载中</div>
        </div>
    );
};

export default Loading;
